module.exports = __webpack_public_path__ + "img/dsci0014.359298ce.jpg";